const CostCenterErrorCodes = {
  CCT00001: '"name" is already being used by another cost center',
} as const;

export default CostCenterErrorCodes;
